import React from 'react';
import {
  SylController,
  SylApi,
} from '@syl-editor/core-utilities';
import ColorSelect from '../Background/ColorSelect';

/* eslint-disable max-len */
const Icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    viewBox="0 0 24 24"
    width="20"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path color-line="true" d="M0 20h24v4H0z" />
    <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
  </svg>
);

export default class ColorController extends SylController<any> {
  public name = 'color';

  public toolbar = {
    className: 'diyColor',
    // tooltip: 'diyBackground', // tip内容
    // eslint-disable-next-line react/display-name
    icon: (editor: SylApi, attrs: any) => {
      const { index, length } = editor.getSelection();
      return (
        <div
          className="diyColor"
          ref={(ref) => {
            if (ref && ref.querySelector('svg') && attrs.color) {
              const paths = ref.querySelectorAll('path');
              ([].slice.call(paths) as SVGClipPathElement[]).forEach((path) => {
                if (path.getAttribute('color-line')) {
                  path.setAttribute('style', `fill: ${attrs.color}`);
                }
              });
            }
          }}
        >
          {Icon}
          <ColorSelect
            id="syl-diy-color-container"
            attrs={attrs}
            onClick={(color) => {
              this.editor.setFormat({
                diyColor: {
                  color,
                },
              });
              // console.log(document.getElementById('syl-diy-color-container'));

              (document.getElementById('syl-diy-color-container') as HTMLDivElement).style.display = 'none';
              this.editor.setSelection({ index: index + length, length: 0 });
            }}
          />
        </div>
      );
    }, // 按钮
    handler: () => {
      // 通过 编辑器实例.commnad.插件名.方法名 调用
      // editor.command.diyBackground.insert();
      (document.getElementById('syl-diy-color-container') as HTMLDivElement).style.display = 'flex';
    },
  };

  public defaultColor = 'rgba(0, 0, 0, 1)';

  public getAttrs = (color: { r: number; g: number; b: number; a: number }) => {
    const rgba = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
    return {
      color: rgba,
    };
  };

  public getValue = (attrs: any) => attrs.color;

  public disable = (editor: SylApi) => {
    const { $from } = editor.view.state.selection;
    if ($from.parent.type.spec.code) return true;
    return false;
  };

  // 注册插件的command
  public command = {
    insert: () => {},
  };
}
